import { render } from "./instruksi-soal-menjodohkan.vue?vue&type=template&id=1404791a"
import script from "./instruksi-soal-menjodohkan.vue?vue&type=script&lang=js"
export * from "./instruksi-soal-menjodohkan.vue?vue&type=script&lang=js"

import "./instruksi-soal-menjodohkan.vue?vue&type=style&index=0&id=1404791a&scope=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__